import {Injectable} from '@angular/core';
import {BaseRequestOptions, Http, Response, URLSearchParams} from '@angular/http';
import {Observable} from 'rxjs/Rx';

import {Bac} from './bac.model';
import {Civilite} from './civilite.model';
import {Commune} from './commune.model';
import {Composant} from './composant.model';
import {Departement} from './departement.model';
import {Discipline} from './discipline.model';
import {Mention} from './mention.model';
import {Pays} from './pays.model';
import {TypeComposant} from './type-composant.model';
import {TypeFormation} from './type-formation.model';
import {Rne} from './rne.model';
import {TypeEtablissement} from './type-etablissement.model';
import {GMention} from './g-mention.model';
import {NiveauAccesDiplome} from './niveau-acces-diplome.model';
import {GradeUniversitaire} from './grade-universitaire.model';
import {Lien} from './lien.model';
import { BacSpecialite } from './bacspecialite.model';

@Injectable()
export class GrhumService {

    private bacUrl = 'api/bacs';
    private bacSpecialiteUrl = 'api/bacSpecialites';
    private civiliteUrl = 'api/civilites';
    private communeUrl = 'api/communes';
    private composantUrl = 'api/composants';
    private departementUrl = 'api/departements';
    private disciplineUrl = 'api/disciplines';
    private mentionUrl = 'api/mentions';
    private gMentionUrl = 'api/g-mentions';
    private paysUrl = 'api/pays';
    private typeComposantUrl = 'api/type-composants';
    private typeFormationUrl = 'api/type-formations';
    private rneUrl = 'api/rnes';
    private typeEtablissementUrl = 'api/type-etablissements';
    private niveauAccesDiplomeUrl = 'api/niveau-acces-diplomes';
    private gradeUniversitaireUrl = 'api/grade-universitaires';
    private lienUrl = 'api/liens';
    private structuresUrl = 'api/structures';

    public static findPaysDansListe(paysListe: Pays[], codePays: string): Pays {
        let paysOrigine: Pays = null;
        if (paysListe && codePays) {
            paysOrigine = paysListe.find(pays => pays.code == codePays);
        }
        if (!paysOrigine) {
            paysOrigine = Pays.getPaysInconnu(codePays);
        }
        return (paysOrigine);
    }

    private static convertResponse(res: any): any {
        res._body = res.json();
        return res;
    }

    private static createRequestOption(req?: any): BaseRequestOptions {
        let options: BaseRequestOptions = new BaseRequestOptions();
        if (req) {
            let params: URLSearchParams = new URLSearchParams();
            params.set('page', req.page);
            params.set('size', req.size);
            if (req.sort) {
                params.paramsMap.set('sort', req.sort);
            }
            params.set('query', req.query);

            options.search = params;
        }
        return options;
    }

    constructor(private http: Http) { }

    findBac(id: number): Observable<Bac> {
        return this.http.get(`${this.bacUrl}/${id}`);
    }
    queryBac(req?: any): Observable<Response> {
        let options = GrhumService.createRequestOption(req);
        return this.http.get(this.bacUrl, options)
            .map((res: any) => GrhumService.convertResponse(res));
    }

    findCivilite(id: number): Observable<Civilite> {
        return this.http.get(`${this.civiliteUrl}/${id}`);
    }
    queryCivilite(req?: any): Observable<Response> {
        let options = GrhumService.createRequestOption(req);
        return this.http.get(this.civiliteUrl, options)
            .map((res: any) => GrhumService.convertResponse(res));
    }

    findTypeEtablissement(id: number): Observable<TypeEtablissement> {
        return this.http.get(`${this.typeEtablissementUrl}/${id}`);
    }
    queryTypeEtablissement(req?: any): Observable<Response> {
        let options = GrhumService.createRequestOption(req);
        return this.http.get(this.typeEtablissementUrl, options)
            .map((res: any) => GrhumService.convertResponse(res));
    }

    findCommune(id: number): Observable<Commune> {
        return this.http.get(`${this.communeUrl}/${id}`);
    }
    queryCommune(req?: any): Observable<Response> {
        let params = new URLSearchParams();
        if (req.departement) {
            params.set('departement', req.departement);
        } else if (req.codePostal) {
            params.set('codePostal', req.codePostal);
        }
        return this.http.get(this.communeUrl, { search: params })
            .map((res: any) => GrhumService.convertResponse(res));
    }

    findComposant(id: number): Observable<Composant> {
        return this.http.get(`${this.composantUrl}/${id}`);
    }
    queryComposant(req?: any): Observable<Response> {
        let params = new URLSearchParams();
        if (req && req.type) {
            params.set('type', req.type);
        }
        if (req && req.typeCampagne) {
            params.set('typeCampagne', req.typeCampagne);
        }
        if (req && req.parentId) {
            params.set('parentId', req.parentId);
        }
        if (req && req.childId) {
            params.set('childId', req.childId);
        }
        if (req && req.disciplineId) {
            params.set('disciplineId', req.disciplineId);
        }
        if (req && req.userId) {
            params.set('userId', req.userId);
        }
        if (req && req.etudiantId) {
            params.set('etudiantId', req.etudiantId);
        }
        if (req && req.reinscription != null) {
            params.set('reinscription', req.reinscription);
        }
        if (req && req.ei  != null) {
            params.set('ei', req.ei);
        }
        if (req && req.lecture != null) {
            params.set('lecture', req.lecture);
        }
        if (req && req.mentionId != null) {
            params.set('mentionId', req.mentionId);
        }
        return this.http.get(this.composantUrl, { search: params })
            .map((res: any) => GrhumService.convertResponse(res));
    }

    composantToLabelValue(composant: Composant[]) {
        let liste = [];
        composant.forEach(comp => liste.push({label: comp.llComposant, value: comp.idComposant}));
        return liste;
    }
    disciplineToLabelValue(discipline: Discipline[]) {
        let liste = [];
        discipline.forEach(disc => liste.push({label: disc.llDiscipline, value: disc.idDiscipline}));
        return liste;
    }

    findLien(id: number): Observable<Lien> {
        return this.http.get(`${this.lienUrl}/${id}`);
    }
    queryLien(req?: any): Observable<Response> {
        let options = GrhumService.createRequestOption(req);
        return this.http.get(this.lienUrl, options)
            .map((res: any) => GrhumService.convertResponse(res));
    }

    findStructure(id: number): Observable<Lien> {
        return this.http.get(`${this.structuresUrl}/${id}`);
    }
    queryStructure(req?: any): Observable<Response> {
        let params = new URLSearchParams();
        if (req.disciplineId) {
            params.set('disciplineId', req.disciplineId);
        }
        return this.http.get(this.structuresUrl, { search: params })
            .map((res: any) => GrhumService.convertResponse(res));
    }

    findDepartement(id: number): Observable<Departement> {
        return this.http.get(`${this.departementUrl}/${id}`);
    }
    queryDepartement(req?: any): Observable<Response> {
        let options = GrhumService.createRequestOption(req);
        return this.http.get(this.departementUrl, options)
            .map((res: any) => GrhumService.convertResponse(res));
    }

    findDiscipline(id: number): Observable<Discipline> {
        return this.http.get(`${this.disciplineUrl}/${id}`);
    }
    queryDiscipline(req?: any): Observable<Response> {
        let options = GrhumService.createRequestOption(req);
        return this.http.get(this.disciplineUrl, options)
            .map((res: any) => GrhumService.convertResponse(res));
    }

    findMention(id: number): Observable<Mention> {
        return this.http.get(`${this.mentionUrl}/${id}`);
    }
    queryMention(req?: any): Observable<Response> {
        let options = GrhumService.createRequestOption(req);
        return this.http.get(this.mentionUrl, options)
            .map((res: any) => GrhumService.convertResponse(res));
    }

    findGMention(id: number): Observable<GMention> {
        return this.http.get(`${this.gMentionUrl}/${id}`);
    }
    queryGMention(req?: any): Observable<Response> {
        let options = GrhumService.createRequestOption(req);
        return this.http.get(this.gMentionUrl, options)
            .map((res: any) => GrhumService.convertResponse(res));
    }

    findPays(id: number): Observable<Pays> {
        return this.http.get(`${this.paysUrl}/${id}`);
    }
    queryPays(req?: any): Observable<Response> {
        let options = GrhumService.createRequestOption(req);
        return this.http.get(this.paysUrl, options)
            .map((res: any) => GrhumService.convertResponse(res));
    }




    findTypeComposant(id: number): Observable<TypeComposant> {
        return this.http.get(`${this.typeComposantUrl}/${id}`);
    }
    queryTypeComposant(req?: any): Observable<Response> {
        let options = GrhumService.createRequestOption(req);
        return this.http.get(this.typeComposantUrl, options)
            .map((res: any) => GrhumService.convertResponse(res))
            ;
    }

    findTypeFormation(id: number): Observable<TypeFormation> {
        return this.http.get(`${this.typeFormationUrl}/${id}`);
    }
    queryTypeFormation(req?: any): Observable<Response> {
        let options = GrhumService.createRequestOption(req);
        return this.http.get(this.typeFormationUrl, options)
            .map((res: any) => GrhumService.convertResponse(res));
    }

    findNiveauAccesDiplome(id: number): Observable<NiveauAccesDiplome> {
        return this.http.get(`${this.niveauAccesDiplomeUrl}/${id}`);
    }
    queryNiveauAccesDiplome(req?: any): Observable<Response> {
        let options = GrhumService.createRequestOption(req);
        return this.http.get(this.niveauAccesDiplomeUrl, options)
            .map((res: any) => GrhumService.convertResponse(res));
    }

    findRne(id: number): Observable<Rne> {
        return this.http.get(`${this.rneUrl}/${id}`);
    }
    queryRne(req?: any): Observable<Response> {
        let params = new URLSearchParams();
        if (req.codeInsee) {
            params.set('codeInsee', req.codeInsee);
        }
        if (req.codePostal) {
            params.set('codePostal', req.codePostal);
        }
        if (req.typeEtabCode) {
            params.set('typeEtabCode', req.typeEtabCode);
        }
        return this.http.get(this.rneUrl, { search: params })
            .map((res: any) => GrhumService.convertResponse(res));
    }

    findGradeUniversitaire(id: number): Observable<GradeUniversitaire> {
        return this.http.get(`${this.gradeUniversitaireUrl}/${id}`);
    }
    queryGradeUniversitaire(req?: any): Observable<Response> {
        let params = new URLSearchParams();
        return this.http.get(this.gradeUniversitaireUrl, { search: params })
            .map((res: any) => GrhumService.convertResponse(res));
    }

    findBacSpecialite(id: number): Observable<BacSpecialite> {
        return this.http.get(`${this.bacSpecialiteUrl}/${id}`);
    }
    queryBacSpecialite(req?: any): Observable<Response> {
        let options = GrhumService.createRequestOption(req);
        return this.http.get(this.bacSpecialiteUrl, options)
            .map((res: any) => GrhumService.convertResponse(res));
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/grhum/grhum.service.ts